var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-form-complet",class:{'menu-form-complet--complet': _vm.complet, 'menu-form-complet--noncomplet': !_vm.complet}},[_c('i',{staticClass:"far fa-check-circle"}),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }